import getWidgetConfig from '../get-widget-config'
import logger from '../logger'

export default function eightlyticsWrapper(
  event,
  { widget: defaultWidgetConfig, ...defaultConfig } = {},
  resolve,
  uuid
) {
  let widgetConfig = {}
  if (uuid) {
    const widgetInstance = window._8select.utils.widgetLoader.find(uuid)
    widgetConfig = (widgetInstance && getWidgetConfig(widgetInstance)) || {}
  }

  const enrichedConfig = {
    ...defaultConfig,
    tenantId: window._8select.config.eightlytics.tenantId || process.env.TENANT_ID,
  }

  if (defaultWidgetConfig || widgetConfig.widget) {
    enrichedConfig.widget = {
      ...defaultWidgetConfig,
      ...widgetConfig.widget,
    }
  }

  if (
    window._8select.config.hooks &&
    window._8select.config.hooks.getEightlyticsCid &&
    typeof window._8select.config.hooks.getEightlyticsCid === 'function'
  ) {
    try {
      enrichedConfig.purchaseSession = window._8select.config.hooks.getEightlyticsCid()
    } catch (error) {
      logger('8.LYTICS: Error in hook "getEightlyticsCid"', error)
    }
  }

  return {
    event,
    enrichedConfig,
    resolve,
  }
}
